import { Badge } from "@/src/components/shadcn/ui/badge";
import { ReferralTag, referralTagLabel } from "@/src/models/documents/referral";

/** Renders one badge per referral tag. */
export function ReferralTagBadges({ tags }: { tags: ReferralTag[] }) {
  return tags.map((tag) => (
    <Badge key={tag} variant="secondary" className="shrink-0">
      {referralTagLabel(tag)}
    </Badge>
  ));
}
